import type { CostEstimate } from '@cartwheel/api/v1'
import { CustomMessageBlock } from './commercial-estimate-display'
import { PerSessionSummary } from './per-session-summary'

interface SelfPaidEstimateDisplayProps {
  estimate: CostEstimate
}

const SELF_PAY_RANGE = '$120-145'

export function SelfPaidEstimateDisplay({ estimate }: SelfPaidEstimateDisplayProps) {
  return (
    <>
      <div className="my-4">
        <div className="flex justify-between py-2 px-4 border-t border-b border-gray-stroke font-medium">
          <span>Session Cost</span>
          <span>{SELF_PAY_RANGE}</span>
        </div>
      </div>

      <div className="flex justify-center">
        <PerSessionSummary label="Self-Paid" labelColor="sand" perSessionAmount={SELF_PAY_RANGE} />
      </div>

      {estimate.custom_message && <CustomMessageBlock message={estimate.custom_message} />}
    </>
  )
}
